import api from '../../request/request'

const searchSkuByKeyword = (teamId, keyword, viewable, page, size) => {
    return api.getPromise('erpProduct/searchSkuByKeyword',
        { teamId, keyword, viewable, page, size }, null, true)
}

const findErpProducts = (teamId, query) => {
    return api.postPromise('erpProduct/findErpProducts', { teamId }, query, null, true)
}

const findErpSkuVoByQrText = (qrText) => {
    return api.getPromise('erpProduct/findErpSkuVoByQrText', { qrText })
}

const findErpSkuVoByTeamIdAndCode = (teamId, code) => {
    return api.getPromise('erpProduct/findErpSkuVoByTeamIdAndCode', {
        teamId,
        code
    })
}

const pullProductBySkuCode = (teamId, code) => {
    return api.getPromise('erpProduct/pullProductBySkuCode', {
        teamId,
        code
    })
}

export default {
    searchSkuByKeyword,
    findErpProducts,
    findErpSkuVoByQrText,
    findErpSkuVoByTeamIdAndCode,
    pullProductBySkuCode
}




// WEBPACK FOOTER //
// ./src/request/newSys/erpProductApi.js